import "./login.css";
import BrandLogoEnd from "../../components/BrandLogo/BrandLogoEnd";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Npm Packages Imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
// Npm Packages Imports End

// Components Start
import ForgotModal from "../../components/ForgotModal/ForgotModal";
import PhoneVerificationComponent from "../../components/PhoneVerificationComponent/PhoneVerificationComponent";
// import SocialAuthProviders from "../../components/SocialAuthProviders/SocialAuthProviders";
// Components End

// Controllers Start
import LoginUser from "../../controllers/auth/Login";
import useLogin from "./scripts/hook";
import SendEmailForVerification from "../../controllers/users/SendEmailForVerification";
import isUserEmailVerified from "../../controllers/auth/isUserEmailVerified";

import EmailTabActiveSVG from "./icons/EmailTabActiveSVG";
import EmailTabSVG from "./icons/EmailTabSVG";
import PhoneTabSVG from "./icons/PhoneTabSVG";
import PhoneTabActiveSVG from "./icons/PhoneTabActiveSVG";
import { ToastContainer } from "react-toastify";
import BrandLogoTop from "../../components/BrandLogo/BrandLogoTop";
import CoverImage from "./icons/CoverImage";
// Form Validate schema Start
// Email Form Start
const schema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string("Password must be string")
    .required("Password is required"),
});
// Email Form End

const schemaPhone = yup.object().shape({
  phone: yup.string().required("Phone number is required").nullable(),
});
// Form Validate schema End

const Login = () => {
  // Auth States
  const [
    PhoneAuthHandler,
    PhoneVerification,
    ,
    Phone,
    setPhone,
    AuthState,
    setAuthState,
    ,
    ,
    ,
    setCodeSent,
    VerifyCode,
    Error,
    setError,
    ,
    ,
    ButtonLoader,
    setButtonLoader,
    goBack,
    ,
    ResendCode,
    CheckEmailExistence,
    CheckExistenceOfEmail,
  ] = useLogin();

  const _PhoneAuthHandler = async (e) => {
    if (e.phone !== "" || e.phone !== null || e.phone !== undefined) {
      if (isValidPhoneNumber(e.phone)) {
        await PhoneAuthHandler();
      } else {
        setErrorPhone("phone", {
          message: "Enter a valid phone number",
        });
      }
    }
  };

  // Form Validate const Start
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const {
    handleSubmit: handleSubmitPhone,
    setError: setErrorPhone,
    control,
    formState: { errors: errorsPhone },
  } = useForm({
    resolver: yupResolver(schemaPhone),
  });
  // Form Validate const End

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [FormDisabled, setFormDisabled] = useState(false);

  const ProcessLogin = async (e) => {
    CheckEmailExistence(e.email);
    setFormDisabled(true);
    const user = await LoginUser(e.email, e.password, e.RememberMe);
    if (user !== false) {
      const { uid } = user;
      dispatch({
        type: "ADD_NEW_USER",
        payload: user,
      });
      if (!(await isUserEmailVerified(uid))) {
        SendEmailForVerification(e.email);
        navigate("/verify/email");
      } else
        setTimeout(() => {
          user.getIdTokenResult().then((idTokenResult) => {
            console.log("Zma Yar: ", idTokenResult.claims);
            if (idTokenResult.claims.admin) {
              navigate("/user/admin/dashboard");
            } else {
              navigate("/user/dashboard");
            }
          });
        }, 1000);
      setFormDisabled(true);
    } else if (user === false) {
      setFormDisabled(false);
      setButtonLoader(false);
    }
  };

  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  useEffect(() => {}, []);
  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 575) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <>
      {PhoneVerification === false ? (
        <div className="login-page-container">
          <div className="container">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-10">
                <div className="authincation-content">
                  <div className="row no-gutters">
                    <div className="login col-xl-6 col-xxl-6 col-lg-12 col-md-12 col-sm-12">
                      <div className="login-cover-photo ">
                        <CoverImage />
                      </div>
                    </div>
                    <div className="login-svg col-xl-6 col-xxl-6 col-lg-12 col-md-12 col-sm-12">
                      <div className="auth-form">
                        <div className="logo-top">
                          <BrandLogoTop />
                        </div>
                        <div className="svg-top d-xl-none d-xxl-none mb-3">
                          <CoverImage />
                        </div>
                        <div className="phone-mail mt-2 mb-3">
                          <p
                            onClick={() => setAuthState("email")}
                            className="auth-state-converter"
                          >
                            {AuthState === "email" ? (
                              <EmailTabActiveSVG />
                            ) : (
                              <EmailTabSVG />
                            )}

                            <span
                              className={`
                       ${
                         AuthState === "email"
                           ? "ml-2 active-tab-in-phone"
                           : "ml-2"
                       }
                       `}
                            >
                              Email
                            </span>
                          </p>
                          <p
                            onClick={() => setAuthState("phone")}
                            className="auth-state-converter"
                          >
                            {AuthState === "phone" ? (
                              <PhoneTabActiveSVG />
                            ) : (
                              <PhoneTabSVG />
                            )}

                            <span
                              className={`
                          ${
                            AuthState === "phone"
                              ? "ml-2 active-tab-in-phone"
                              : "ml-2"
                          }
                          `}
                            >
                              Phone
                            </span>
                          </p>
                        </div>
                        {AuthState === "email" && (
                          <form onSubmit={handleSubmit(ProcessLogin)}>
                            <h2 className="form-heading">Login</h2>
                            <div className="form-group form-group-style">
                              <input
                                type="email"
                                className="form-control  form-input-field"
                                placeholder="Enter Your Email"
                                {...register("email", { required: true })}
                                disabled={FormDisabled}
                                autoFocus
                              />
                              <small className="errorMessage mb-n2 pt-1">
                                {errors?.email?.message}
                              </small>
                            </div>
                            <div className="form-group form-group-style">
                              <span
                                onClick={togglePassword}
                                className={`loginOpenCloseEyeIcon ${
                                  passwordShown
                                    ? "bi bi-eye-fill"
                                    : "bi bi-eye-slash-fill"
                                } `}
                              ></span>
                              <input
                                type={passwordShown ? "text" : "password"}
                                className="form-control form-input-field "
                                placeholder="Enter Your Password"
                                name="password"
                                {...register("password")}
                                disabled={FormDisabled}
                              />
                              <p className="errorMessage">
                                {errors?.password?.message}
                              </p>
                            </div>
                            <div className="remember-me-forgot-container">
                              <div className="form-group">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="basic_checkbox_1"
                                    defaultChecked={true}
                                    {...register("RememberMe")}
                                  />
                                  <label
                                    className="login-labels"
                                    htmlFor="basic_checkbox_1"
                                  >
                                    Remember me
                                  </label>
                                </div>
                              </div>

                              <div className="form-group">
                                {AuthState === "email" && (
                                  <ForgotModal
                                    CheckExistenceOfEmail={
                                      CheckExistenceOfEmail
                                    }
                                  />
                                )}
                              </div>
                            </div>
                            <input
                              type={"submit"}
                              style={{ display: "none" }}
                              id={"emailLoginSubmitButton"}
                            />
                          </form>
                        )}

                        {AuthState === "phone" && (
                          <form onSubmit={handleSubmitPhone(_PhoneAuthHandler)}>
                            <div className="form-group m-0">
                              <label className=" mb-1  form-field-label">
                                Phone Number
                              </label>
                              <PhoneInputWithCountry
                                name="phone"
                                className="form-phone-input-field"
                                defaultCountry={"PK"}
                                international={true}
                                countryCallingCodeEditable={false}
                                initialValueFormat="national"
                                smartCaret={true}
                                control={control}
                                onChange={(e) => {
                                  setPhone(e);
                                }}
                              />

                              {errorsPhone && (
                                <p className="errorMessage">
                                  {errorsPhone?.phone?.message}
                                </p>
                              )}
                            </div>

                            <input
                              type={"submit"}
                              style={{ display: "none" }}
                              id={"phoneLoginSubmitButton"}
                            />
                          </form>
                        )}

                        <div className="text-center">
                          <button
                            type="submit"
                            className="form-submit-button py-2"
                            disabled={FormDisabled || ButtonLoader}
                            onClick={
                              AuthState === "phone"
                                ? () =>
                                    document
                                      .getElementById("phoneLoginSubmitButton")
                                      .click()
                                : () =>
                                    document
                                      .getElementById("emailLoginSubmitButton")
                                      .click()
                            }
                          >
                            {(FormDisabled || ButtonLoader) && (
                              <span className="spinner-border spinner-border-sm mr-1"></span>
                            )}
                            {AuthState === "phone" ? "Next" : "Login"}
                          </button>
                        </div>
                        {AuthState === "phone" && (
                          <p className="no-account-text mt-2">
                            Don't have an account? Don't worry we'll create when
                            you proceed
                          </p>
                        )}

                        {AuthState === "email" && (
                          <div className="new-account mt-3">
                            <p>
                              Don't have an account? Register using &nbsp;
                              <Link
                                to="/register"
                                style={{
                                  color: "#4C3CA6",
                                  textDecoration: "underline",
                                }}
                              >
                                Email
                              </Link>
                              &nbsp; Or &nbsp;
                              <span
                                onClick={() => setAuthState("phone")}
                                style={{
                                  color: "#4C3CA6",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                Phone
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="logo-end">
                    <BrandLogoEnd />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PhoneVerificationComponent
          {...{
            VerifyCode,
            setCodeSent,
            setError,
            Error,
            ButtonLoader,
            goBack,
            ResendCode,
            Phone,
            setPhone,
          }}
        />
      )}

      <ToastContainer />
    </>
  );
};

export default Login;
